// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({2239: "ActionToast",2733: "NftSecondaryMarketModal",2944: "RecentlyViewed",5338: "NftPdpZoomModal",8756: "EthereumWallet",9289: "ModelViewer",}[chunkId] || chunkId) + ".559.0.0." + {2239: "fd380fbd4627a555",2733: "f36ec8aeaae50124",2944: "020ad6979424e68c",5233: "36e9a0b872e8e861",5338: "5985d1f398af18f4",8756: "3c8cecd20d3b4042",9289: "e887823dd0b5e3f7",}[chunkId] + ".css"
}